import type { BlockNoteEditor } from "@blocknote/core";
import { downloadBriefAsDoc, downloadBriefAsPdf } from "./briefExport";
import { syncTokenizedUrlsFromDom } from "./briefExportMedia";
import { importBriefFromFile } from "./briefImportFile";

/** Escape & in Firebase URLs so &token= survives HTML save/load. */
function escapeFirebaseUrlsInHtml(html: string): string {
  return html.replace(
    /https:\/\/firebasestorage\.googleapis\.com\/[^"'>\s]+/g,
    (url) => url.replace(/&(?!amp;)/gi, "&amp;")
  );
}

/** Serialize editor document to HTML for formV2 persistence */
export const editorDocumentToHtml = (
  editor: BlockNoteEditor,
  options?: { syncTokens?: boolean }
): string => {
  if (options?.syncTokens !== false) {
    syncTokenizedUrlsFromDom(editor);
  }
  return escapeFirebaseUrlsInHtml(editor.blocksToFullHTML(editor.document));
};

export { downloadBriefAsDoc, downloadBriefAsPdf, importBriefFromFile };
